import $ from 'jquery';

let Cookies = {};  

Cookies.initialize = () => {
    tarteaucitron.init({
        "bodyPosition": "bottom", /* or top to bring it as first element for accessibility */
    
        "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
        "cookieName": "tarteaucitron", /* Cookie name */
    
        "orientation": "bottom", /* Banner position (top - bottom - middle - popup) */
    
        "groupServices": false, /* Group services by category */
        "showDetailsOnClick": true, /* Click to expand the description */
        "serviceDefaultState": "wait", /* Default state (true - wait - false) */
    
        "showAlertSmall": false, /* Show the small banner on bottom right */
        "cookieslist": false, /* Show the cookie list */
        
        "showIcon": false, /* Show cookie icon to manage cookies */
        // "iconSrc": "", /* Optionnal: URL or base64 encoded image */
        "iconPosition": "BottomRight", /* Position of the icon between BottomRight, BottomLeft, TopRight and TopLeft */
    
        "adblocker": false, /* Show a Warning if an adblocker is detected */
    
        "DenyAllCta" : true, /* Show the deny all button */
        "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
        "highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */
    
        "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */
    
        "removeCredit": true, /* Remove credit link */
        "moreInfoLink": false, /* Show more info link */
        "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */
        "useExternalJs": false, /* If false, the tarteaucitron.services.js file will be loaded */
    
        //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for subdomain website */
    
        "readmoreLink": "", /* Change the default readmore link pointing to tarteaucitron.io */
        
        "mandatory": true, /* Show a message about mandatory cookies */
        "mandatoryCta": true, /* Show the disabled accept button when mandatory on */
    });
    
    tarteaucitron.user.gtagUa = 'G-R7Y4G20G15';
    //tarteaucitron.user.gtagMore = function () {};
    (tarteaucitron.job = tarteaucitron.job || []).push('gtag');
    tarteaucitronCustomText = {
        alertBigPrivacy: "Ce site utilise des cookies dans un but strictement limité à la seule mesure de l’audience du site de manière anonyme.",
        close:"<div class='tarteaucitronClosePanelIcon'>X</div>Fermer"
    }
}

export default Cookies;